import { inject, Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'environments/environment';

@Injectable({ providedIn: 'root' })
export class IconsService {
  /**
   * Constructor
   */
  constructor() {
    const domSanitizer = inject(DomSanitizer);
    const matIconRegistry = inject(MatIconRegistry);

    // Register icon sets
    matIconRegistry.addSvgIconSet(domSanitizer.bypassSecurityTrustResourceUrl(`${environment.appUrl}/assets/icons/material-twotone.svg`));
    matIconRegistry.addSvgIconSetInNamespace('mat_outline', domSanitizer.bypassSecurityTrustResourceUrl(`${environment.appUrl}/assets/icons/material-outline.svg`));
    matIconRegistry.addSvgIconSetInNamespace('mat_solid', domSanitizer.bypassSecurityTrustResourceUrl(`${environment.appUrl}/assets/icons/material-solid.svg`));
    matIconRegistry.addSvgIconSetInNamespace('feather', domSanitizer.bypassSecurityTrustResourceUrl(`${environment.appUrl}/assets/icons/feather.svg`));
    matIconRegistry.addSvgIconSetInNamespace('heroicons_outline', domSanitizer.bypassSecurityTrustResourceUrl(`${environment.appUrl}/assets/icons/heroicons-outline.svg`));
    matIconRegistry.addSvgIconSetInNamespace('heroicons_solid', domSanitizer.bypassSecurityTrustResourceUrl(`${environment.appUrl}/assets/icons/heroicons-solid.svg`));
    matIconRegistry.addSvgIconSetInNamespace('heroicons_mini', domSanitizer.bypassSecurityTrustResourceUrl(`${environment.appUrl}/assets/icons/heroicons-mini.svg`));
    matIconRegistry.addSvgIcon('half-tent', domSanitizer.bypassSecurityTrustResourceUrl(`${environment.appUrl}/assets/icons/half-tent.svg`));
    matIconRegistry.addSvgIcon('full-tent', domSanitizer.bypassSecurityTrustResourceUrl(`${environment.appUrl}/assets/icons/full-tent.svg`));
  }
}
